import React from "react";
import { useTranslation } from "react-i18next";
const NodeTitle = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-4">
      <p className="text-right text-red-500">
        <span className="font-bold text-red-500">*</span> {t("NoteBuyForMe")}
      </p>
    </div>
  );
};

export default NodeTitle;
